import tailwindConfig from "../../tailwind.config";

export enum Breakpoint {
  sm = "sm",
  md = "md",
  lg = "lg",
  xl = "xl",
  "2xl" = "2xl",
  "3xl" = "3xl"
}

/**
 * Get numerical breakpoint value from a given breakpoint name
 * @param breakpoint Target breakpoint
 */
const resolveBreakpoint = (breakpoint: Breakpoint) => {
  const breakpointWithUnit = tailwindConfig.theme.screens[breakpoint];

  if (!breakpointWithUnit) {
    throw Error(`Breakpoint '${breakpoint}' is not defined`);
  }

  // We are only interested in pixel-based values, but without the unit
  const matches = /(\d+)px/i.exec(breakpointWithUnit);

  // First match is always whole input, second is capture group
  // which is the one we want
  if (matches && matches.length >= 2) {
    return Number(matches[1]);
  } else {
    throw Error(`Invalid value for breakpoint '${breakpoint}'`);
  }
};

export const BreakpointValues = {
  sm: resolveBreakpoint(Breakpoint.sm),
  md: resolveBreakpoint(Breakpoint.md),
  lg: resolveBreakpoint(Breakpoint.lg),
  xl: resolveBreakpoint(Breakpoint.xl),
  "2xl": resolveBreakpoint(Breakpoint["2xl"]),
  "3xl": resolveBreakpoint(Breakpoint["3xl"])
};
